

/*
 * Search toggles
 */

/* global biro_body */


// On page load
jQuery( function( $ ) {

	// Init
	var msfw    = $( '.menu-search-form-wrap' );
	var overlay = $( '<div class="overlay-content d-none d-lg-block"></div>' );

	// Desktop search toggle
	biro_body.on( 'click', '.menu-search-toggle', function() {

		// Init
		var el = $( this );

		if ( el.attr( 'aria-expanded' ) === 'false' ) {

			// Place overlay to cover content
			overlay.appendTo( biro_body );

			// Show form
			msfw.slideDown(
				200,
				function() {
					el.attr( 'aria-expanded', 'true' );
					msfw.find( '.menu-search-text' ).focus();
				}
			);

		} else {

			// Hide form
			msfw.slideUp(
				200,
				function() {
					el.attr( 'aria-expanded', 'false' ).blur();
				}
			);

			// Remove overlay
			overlay.remove();


		}

	});

});
